import {SystemStatusGroup} from "../../../../../core/gd/const/system-status"
import {ItemsHighlightMode, TasksViewAppSettings} from "../../../../../core/gd-modules/tasks-view/core/@types"
import {SystemColumnType} from "../../../../../core/gd-modules/manager/columns/types"
import {CardViewLayout} from "../../../../../core/gd-ui/card-view-selector/card-view-selector"

export const Summary_DefaultAppSettings: TasksViewAppSettings = {
    columns                 : [
        {
            id      : SystemColumnType.TITLE
        },
        {
            id      : SystemColumnType.STATUS
        },
        {
            id      : SystemColumnType.COMMENTS
        },
        {
            id      : SystemColumnType.START_END_DATE
        },
        {
            id      : SystemColumnType.OWNER
        },
        {
            id      : SystemColumnType.PROJECT_HEALTH
        },
        {
            id      : SystemColumnType.OPEN_ALL
        },
        {
            id      : SystemColumnType.PROJECT_PATH
        },
    ],

    systemStatusFilter      : SystemStatusGroup.OPEN, // used is task table to show hide archived tasks
    // sortBy              : null,  // current sort by column value
    sorting                 : null,  // current sort by column value
    grouping                : null,
    filters                 : {},
    highlightItemsMode      : ItemsHighlightMode.NONE,

    areEmptyFoldersHidden   : false,
    areEmptyGroupsHidden    : true,
    areAddRowsHidden        : false,
    itemViewBorderPosition  : CardViewLayout.COLOR_CODING_NONE,
    colorTasksFieldId       : 'statusId',
}


//
// export default {
//     columns             : _.map(['2','6','22','27','25','24','23'], id=>({id: id/*, aggregate: null*/})), // portfoio special!
//     systemStatusFilter  : 'open', // used is task table to show hide archived tasks
//     sortBy              : null,  // current sort by column value
//     filters             : {},
// }
